import React from "react";

const Empty:React.FC = (props) => {
    return <div className="empty-box">
        <p className="iconfont">&#xe7d5;</p>
        <div className="child">
            {
                props.children
            }
        </div>
    </div>
}

export default Empty
